export const RankTypeEnum = {
  ORDER_NUM: 1,
  SALES_AMOUNT: 2,
  SALES_AMOUNT_BY_ACTUAL_PRICE: 8,
  EARNINGS: 3,
  PERSONAGE_RESULT: 4,
  AGENT_RECRUIT_NEW_NUM: 5
}

export const tabColum = [
  {
    title: '订单量',
    key: RankTypeEnum.ORDER_NUM
  },
  {
    title: '销售额',
    key: RankTypeEnum.SALES_AMOUNT,
    helpMessage: '按团购价（用户价）统计销售额以及排序，不扣减其他优惠'
  },
  {
    title: '销售额',
    key: RankTypeEnum.SALES_AMOUNT_BY_ACTUAL_PRICE,
    helpMessage: '按下单用户代理价计算销售额以及排序，不扣减其他优惠'
  },
  {
    title: '收 益',
    key: RankTypeEnum.EARNINGS
  },
  {
    title: '个人业绩',
    key: RankTypeEnum.PERSONAGE_RESULT
  },
  {
    title: '招新人数',
    key: RankTypeEnum.AGENT_RECRUIT_NEW_NUM
  }
]

export const listTitleColum = [
  {
    title: '排名',
    key: 'rank',
    span: 6,
    align: 'left'
  },
  {
    title: '用户',
    span: 12,
    key: 'user',
    align: 'left'
  },
  {
    title: '订单量(单)',
    span: 6,
    key: RankTypeEnum.ORDER_NUM,
    align: 'center'
  },
  {
    title: '销售额(元)',
    span: 6,
    key: RankTypeEnum.SALES_AMOUNT,
    align: 'center'
  },
  {
    title: '销售额(元)',
    span: 6,
    key: RankTypeEnum.SALES_AMOUNT_BY_ACTUAL_PRICE,
    align: 'center'
  },
  {
    title: '收益(元)',
    span: 6,
    key: RankTypeEnum.EARNINGS,
    align: 'center'
  },
  {
    title: '个人进货(元)',
    span: 6,
    key: RankTypeEnum.PERSONAGE_RESULT,
    align: 'center'
  },
  {
    title: '代理招新(人)',
    span: 6,
    key: RankTypeEnum.AGENT_RECRUIT_NEW_NUM,
    align: 'center'
  }
]
